import { useKrispNoiseFilter } from '@livekit/components-react/krisp';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
export const EnableKrisp = observer(function EnableKrisp() {
    const krisp = useKrispNoiseFilter();
    useEffect(() => {
        if (krisp.isNoiseFilterEnabled || krisp.isNoiseFilterPending) {
            return;
        }
        krisp.setNoiseFilterEnabled(true);
    }, [krisp]);
    return null;
});
